import { render, staticRenderFns } from "./MailMagazineSelect.vue?vue&type=template&id=7a4758ea&scoped=true&lang=pug&"
import script from "./MailMagazineSelect.vue?vue&type=script&lang=js&"
export * from "./MailMagazineSelect.vue?vue&type=script&lang=js&"
import style0 from "./MailMagazineSelect.vue?vue&type=style&index=0&id=7a4758ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4758ea",
  null
  
)

/* custom blocks */
import block0 from "./MailMagazineSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports